import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { PlanCancelPayload } from 'Interfaces/Billing';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: PlanCancelPayload) =>
    $actions.billing.cancelPlan(dispatch, payload),
  );
};
